// extracted by mini-css-extract-plugin
export default {"slideContainer":"ImageSlider_slideContainer__dZcl7"};